import PropTypes from "prop-types";
import { Card, CardHeader, CardContent, Typography } from "@mui/material";
import { withStyles } from "@mui/styles";

const EnhancedCard = ({
  title,
  classes,
  children,
  action,
  style = {},
  cardHeaderStyle = {},
  cardContentRoot = {},
}) => (
  <Card style={style}>
    <CardHeader
      classes={{ root: classes.headerContainer, action: classes.action }}
      title={
        <Typography
          variant="h5"
          style={cardHeaderStyle}
          className={classes.header}
        >
          {title}
        </Typography>
      }
      action={action}
    />
    <CardContent style={cardContentRoot}>{children}</CardContent>
  </Card>
);

EnhancedCard.defaultProps = {
  title: "",
};

EnhancedCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  classes: PropTypes.object.isRequired,
  action: PropTypes.node,
  cardContentRoot: PropTypes.object,
};

const styles = ({ palette }) => ({
  headerContainer: {
    backgroundColor: palette.common.black,
  },
  header: {
    fontSize: "18px",
    fontWeight: "bold",
    color: palette.common.white,
    textTransform: "uppercase",
  },
  action: {
    alignSelf: "center !important",
    marginTop: "0 !important",
    marginRight: "0 !important",
    marginBottom: "0 !important",
  },
});

export default withStyles(styles)(EnhancedCard);
